<template>
    <div class="min-h-screen">
  
      <!-- Hero Section -->
      <section class="w-full bg-gray-800 text-white text-start py-16 px-4 md:px-8">
        <div class="max-w-7xl mx-auto grid md:grid-cols-2 gap-8 mb-8 items-center">
          <!-- Text Content -->
          <div>
            <h1 class="md:text-4xl sm:text-3xl text-3xl font-semibold mb-4">
              Discover Exciting Opportunities in Nepal
            </h1>
            <p class="md:text-xl text-lg mb-8">
              Search and explore academic, summer programs, internships, and more.
            </p>
          </div>

          <!-- Image Content -->
          <div class="flex justify-center">
            <img
              src="https://img.freepik.com/free-vector/kathmandu-nepal-skyline-with-panorama-white-background-vector-illustration-business-travel-tourism-concept-with-modern-buildings-image-banner-web-site_596401-113.jpg"
              alt="Kathmandu Skyline"
              class="rounded-xl shadow-lg max-w-full h-auto"
            />
          </div>
        </div>

        <universal-search class="mx-auto md:max-w-xl" />
  
        <!-- Categories Section -->
        <div class="max-w-7xl mt-16 px-4">
          <h2 class="text-2xl text-white font-semibold text-center mb-10">Browse By Categories</h2>
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
            <category-card
              v-for="(item, index) in categories"
              :key="index"
              :category="item"
              class="h-full"
            />
          </div>
        </div>

  
        <!-- Popular Opportunities Section -->
        <div class="max-w-7xl mt-16">
          <h2 class="text-2xl text-white font-semibold text-center mb-10">Featured Opportunities</h2>
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                <opportunity-card
                v-for="(item, index) in opportunities"
                :key="index"
                :opportunity="item"
                class="h-full"
              />
            </div>
        </div>

        <section class="py-12 bg-gray-800 text-white">
          <frequently-asked-questions></frequently-asked-questions>
        </section>
  
        <!-- CTA Section -->
        <section class="bg-gradient-to-t from-gray-950 via-gray-900 to-gray-800 md:rounded-xl rounded-lg py-12 mt-16 text-center">
          <h2 class="text-2xl text-white font-semibold mb-4">Ready to find your next opportunity?</h2>
          <p class="text-lg text-gray-400 mb-8">Join us and explore the best opportunities in Nepal!</p>
          <router-link to="/register">
            <primary-button class="px-8 py-3 lg:text-md md:text-base text-sm">Sign Up Now</primary-button>
          </router-link>
        </section>

      </section>
  
      <!-- Footer Section -->
      <app-footer />
  
    </div>
  </template>
  
  <script setup>
  import UniversalSearch from '../components/search/UniversalSearch.vue'
  import CategoryCard from '../components/app/CategoryCard.vue'
  import OpportunityCard from '../components/opp/OpportunityCard.vue'
  import PrimaryButton from '../components/button/PrimaryButton.vue'
  import FrequentlyAskedQuestions from '@/components/app/FrequentlyAskedQuestions.vue'
  import { getAllCategories } from '@/utils/category'
  import { ref, onMounted } from 'vue'
  import { getAllOpportunities } from '@/utils/opportunity'
 
  const categories = ref({})
  const opportunities = ref({})
  onMounted(async () => {
    categories.value = await getAllCategories(4)
    opportunities.value = await getAllOpportunities(4)
  })
  </script>
  
  <style scoped>
  /* Add any custom styles if necessary */
  </style>
  